import React from 'react';
import { useState, useEffect, Fragment, useRef } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Alert from 'react-bootstrap/Alert';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaDownload } from "react-icons/fa6";
import DataTable from 'react-data-table-component';
import uploadRuleSetJson from '../../../json-data/uploadruleset.json';
import UploadRuleConfirmation from './Modal-Dialog/upload-ruleconfirmation';
import { configData } from "../../../config/systemconfigurationconstants";
import UseLambdaInvocations from '../../../hooks/useLambdaInvocations';
import * as AWS from 'aws-sdk';
import lambdaConfig from '../../../hooks/lambdaConfig';
import { ToastContainer, toast } from "react-toastify";
import RpmTable from './rpm-table';
import RuleTemplateDownload from './Modal-Dialog/rule-template-download';
import { IoMdClose } from "react-icons/io";
import { useEncryption } from '../../../customHooks/useEncryption';
let ExcelRuleConfigInfoForUpload = []
let usecaseInfoForUpload = []
const UploadRuleSet = () => {
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const fileInputRef = useRef(null);
    const { invokeLambda, loading, error } = UseLambdaInvocations();
    const [timestamp, setTimestamp] = useState('');
    const [clientList, setClientList] = useState([]);
    const [usecaseInfo, setUsecaseInfo] = useState([])
    const [excelRuleConfigInfo, setExcelRuleConfigInfo] = useState([])
    const [ruleType, setRuleType] = useState("");
    const [usecase, setUsecase] = useState("");
    const [usecasename, setUsecasename] = useState("");
    const [client, setClient] = useState("");
    const [clientname, setClientname] = useState("");
    const [file, setFile] = useState(null);

    const [applyImmediately, setApplyImmediately] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [errors, setErrors] = useState({});

    const [uploadIdxBucket, setUploadIdxBucket] = useState();
    const [idxAWSAccessKey, setIdxAWSAccessKey] = useState();
    const [idxAWSSecretKey, setIdxAWSSecretKey] = useState();
    const [ruleFileName, setRuleFileName] = useState();
    const [currentRpmFileName, setCurrentRpmFileName] = useState();
    const [rpmTableValues, setRpmTableValues] = useState();
    const [uploadDisplayHide, setUploadDisplayHide] = useState(false);
    const [dotloader, setDotLoader] = useState(false);
    const [configjson, setConfigjson] = useState();
    const [showRuleTemplate, setShowRuleTemplate] = useState(false);
    const closeDownloadTemplate = () => setShowRuleTemplate(false);
    const showDownloadTemplate = () => setShowRuleTemplate(true);

    useEffect(() => {
        // getCurrentRpm();
        // generateTimestamp();
        getUsecaseclientInfo();
    }, [])
    const generateTimestamp = () => {
        // const now = new Date();
        // // Format date: YYYY-MM-DD
        // const formattedDate = now.toISOString().split('T')[0];
        // // Format time: HH:MM:SS (without milliseconds or timezone)
        // const formattedTime = now.toTimeString().split(' ')[0];
        // return formattedDate + "_" + formattedTime;
        const now = new Date();

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        return `${year}${month}${day}${hours}${minutes}${seconds}`;

    };
    const getUsecaseclientInfo = async () => {
        const lambda = new AWS.Lambda({
            region: configData.LAMBDA_REGION,
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
            httpOptions: {
                timeout: 180000
            }
        });
        // Disable SDK-level retries for all AWS services
        AWS.config.update({
            maxRetries: 0
        });

        const payloadData = {
            Command: configData.GET_CLIENT_USECASE_INFO,
            SecurityId: "",
            SecurityToken: localStorage.getItem("SecurityToken"),
            EventContextId: "",
            CallerSourceId: "",
            CallerSourceName: ""
        };

        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(payloadData)
        };
        try {
            // Wrap lambda.invoke in a Promise to use await
            const lambdaResponse = await new Promise((resolve, reject) => {
                lambda.invoke(params, (err, data) => {
                    if (err) reject(err);
                    else resolve(data);
                });
            });

            const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
            if (parsedPayload.statusCode === 200) {
                const parsedBody = JSON.parse(parsedPayload.body);
                const parsedoutput = JSON.parse(parsedBody.Output)
                console.log(JSON.parse(parsedBody.Output))
                ExcelRuleConfigInfoForUpload = parsedoutput.ExcelRuleConfigInfo
                usecaseInfoForUpload = parsedoutput.UseCaseClientInfo
                localStorage.setItem("usecaseInfo", JSON.stringify(usecaseInfoForUpload))
                setUsecaseInfo(parsedoutput.UseCaseClientInfo)
                setExcelRuleConfigInfo(parsedoutput.ExcelRuleConfigInfo)
                console.log(parsedoutput.UseCaseClientInfo)
                console.log(parsedoutput.ExcelRuleConfigInfo)
                console.log(ExcelRuleConfigInfoForUpload)
                console.log(usecaseInfoForUpload)
            }
            else {
                // setDotLoader(false);
            }
        } catch (error) {
            // setDotLoader(false);
            console.error('Error in getCurrentRpm:', error);
        }

    }
    const ruleConfigForUi = async (clientnameforconfig) => {
        // setDotLoader(false);
        const lambda = new AWS.Lambda({
            region: configData.LAMBDA_REGION,
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
            httpOptions: {
                timeout: 180000
            }
        });
        // Disable SDK-level retries for all AWS services
        AWS.config.update({
            maxRetries: 0
        });

        const payloadData = {
            Command: configData.GET_CONFIG_FOR_UI,
            ClientShortName: clientnameforconfig,
            UseCaseShortName: usecasename
        };

        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(payloadData)
        };

        try {
            // Wrap lambda.invoke in a Promise to use await
            const lambdaResponse = await new Promise((resolve, reject) => {
                lambda.invoke(params, (err, data) => {
                    if (err) reject(err);
                    else resolve(data);
                });
            });

            const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
            if (parsedPayload.statusCode === 200) {
                const parsedBody = JSON.parse(parsedPayload.body);
                setUploadIdxBucket(parsedBody.IDXBucket)
                setIdxAWSAccessKey(parsedBody.IDXAWSAccessKey)
                setIdxAWSSecretKey(parsedBody.IDXAWSSecretKey)
                setConfigjson(parsedBody);
                // setTimeout(() => {
                //     setDotLoader(true);
                // }, 1000);

            }
            else {
                // setDotLoader(false);
            }
        } catch (error) {
            // setDotLoader(false);
            console.error('Error in getCurrentRpm:', error);
        }

        // setDotLoader(false);
        // try {
        //     const parsedBody = await invokeLambda(configData.GET_CONFIG_FOR_UI, {
        //         // ...lambdaConfig,
        //         // SecurityToken: localStorage.getItem('SecurityToken'),
        //         ClientShortName: localStorage.getItem('ClientShortName').trim(),
        //         UseCaseShortName: localStorage.getItem('UseCaseShortName').trim()
        //     });

        //     if (parsedBody.Status) {
        //         setUploadIdxBucket(parsedBody.IDXBucket);
        //         // setUserDetails(parsedBody.UserInfo)
        //         // setUseCaseListForUserCreation(parsedBody.UseCaseClientInfo[0].UseCase)
        //         // setUserRoleListForUserCreation(parsedBody.UserRoleInfo)
        //         // setUserProviderForUserCreation(parsedBody.Prvdrslst)
        //         // setTimeout(() => {
        //         //     setDotLoader(true);
        //         // }, 1000);
        //     } else {
        //         // setDotLoader(false);
        //     }
        // } catch (err) {
        //     // Handle error if needed
        //     // setDotLoader(false);

        // }
    }
    // const getCurrentRpm = async () => {
    //     const lambda = new AWS.Lambda({
    //         region: configData.LAMBDA_REGION,
    //         accessKeyId: configData.BASE_ACCESS_KEY_ID,
    //         secretAccessKey: configData.BASE_SECRET_ACCESS_KEY
    //     });
    //     const data = {
    //         Command: configData.GET_CURRENT_RPM,
    //         SecurityToken: localStorage.getItem('SecurityToken'),
    //         ClientId: localStorage.getItem('ExternalId').trim(),
    //         UseCaseId: localStorage.getItem('DefaultUseCase').trim(),
    //         RuleTypeId: 1,
    //         SecurityId: null,
    //         EventContextId: null,
    //         CallerSourceId: null,
    //         CallerSourceName: null,
    //     };
    //     const params = {
    //         FunctionName: configData.LAMBDA_FUNCTION_NAME1,
    //         Payload: JSON.stringify(data)
    //     };

    //     lambda.invoke(params, (err, data) => {
    //         if (err) {
    //             console.log(err, err.stack);
    //         } else {
    //             let lambdaResponse = JSON.parse(data.Payload.toString());
    //             const parsedBody = JSON.parse(lambdaResponse.body);
    //             if (parsedBody.Status === true) {
    //                 const foldernamesplit = parsedBody.Output;
    //                 const splitsname = foldernamesplit.split('/')
    //                 let mergeKeyFile = configData.BUCKET_NAME + '/' + splitsname[0];
    //                 AWS.config.credentials = new AWS.Credentials({
    //                     accessKeyId: configData.BASE_ACCESS_KEY_ID,
    //                     secretAccessKey: configData.BASE_SECRET_ACCESS_KEY
    //                 });
    //                 // // Create an S3 object instance
    //                 const s3 = new AWS.S3({ signatureVersion: 'v4', region: configData.LAMBDA_REGION });
    //                 try {
    //                     // const data = await s3.getObject({ Bucket: mergeKeyFile, Key: splitsname[1], IfModifiedSince: new Date(0) }).promise();
    //                     const data = await s3.getObject({ Bucket: mergeKeyFile, Key: splitsname[1], IfModifiedSince: new Date(0) }).promise();
    //                     // Parse the JSON data
    //                     let datajsonobjectData = new Uint8Array(data.Body); // Use the encoding necessary
    //                     let datajsondecode = new TextDecoder('utf-8').decode(datajsonobjectData);
    //                     let getdatajsondata = JSON.parse(JSON.parse(JSON.stringify(datajsondecode)))
    //                     console.log("For timer", getdatajsondata);

    //                 } catch (error) {
    //                     console.error('Error fetching JSON from S3:', error);
    //                 }
    //             }
    //             else {

    //             }
    //         }
    //     });
    // }
    // Validation on submit
    const rpmUpload = async () => {
        if (validate()) {
            setDotLoader(true);
            const lambda = new AWS.Lambda({
                region: configData.LAMBDA_REGION,
                accessKeyId: decrypt(getCookie('ak')),
                secretAccessKey: decrypt(getCookie('sk')),
                // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
                httpOptions: {
                    timeout: 180000
                }
            });
            // Disable SDK-level retries for all AWS services
            AWS.config.update({
                maxRetries: 0
            });

            const payloadData = {
                Command: configData.GET_CURRENT_RPM,
                SecurityToken: localStorage.getItem('SecurityToken'),
                ClientId: client,
                UseCaseId: usecase,
                RuleTypeId: ruleType,
                SecurityId: null,
                EventContextId: null,
                CallerSourceId: null,
                CallerSourceName: null,
            };

            const params = {
                FunctionName: configData.LAMBDA_FUNCTION_NAME1,
                Payload: JSON.stringify(payloadData)
            };

            try {
                // Wrap lambda.invoke in a Promise to use await
                const lambdaResponse = await new Promise((resolve, reject) => {
                    lambda.invoke(params, (err, data) => {
                        if (err) reject(err);
                        else resolve(data);
                    });
                });

                const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
                const parsedBody = JSON.parse(parsedPayload.body);

                if (parsedBody.Status === true) {
                    const foldernamesplit = parsedBody.Output;
                    const splitsname = foldernamesplit.split('/');
                    let mergeKeyFile = configData.BUCKET_NAME + '/' + splitsname[0];

                    AWS.config.credentials = new AWS.Credentials({
                        accessKeyId: decrypt(getCookie('ak')),
                        secretAccessKey: decrypt(getCookie('sk'))
                    });

                    const s3 = new AWS.S3({ signatureVersion: 'v4', region: configData.LAMBDA_REGION });

                    const s3Data = await s3.getObject({
                        Bucket: mergeKeyFile,
                        Key: splitsname[1],
                        IfModifiedSince: new Date(0)
                    }).promise();

                    const dataBuffer = new Uint8Array(s3Data.Body);
                    const dataJson = new TextDecoder('utf-8').decode(dataBuffer);
                    const getdatajsondata = JSON.parse(dataJson);
                    let currentRPMdata = {
                        "RPMData": [],
                        "NewFormFieldData": [],
                        "CurrentRPM": getdatajsondata.CurrentRPM
                    }
                    uploadCurrentRPM(currentRPMdata);
                    // ruleSheetUpload();
                    console.log("For timer", getdatajsondata);
                }
            } catch (error) {
                setDotLoader(true);
                console.error('Error in getCurrentRpm:', error);
            }
        }
    };
    const uploadCurrentRPM = async (currentRPMdata) => {
        setDotLoader(true);
        const generateCurrentRpmFileName =
            client + "-" +
            usecase +
            "_InCompareRPMData_" + generateTimestamp() + ".json";
        console.log(generateCurrentRpmFileName);
        setCurrentRpmFileName(generateCurrentRpmFileName);

        AWS.config.update({
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            region: configData.LAMBDA_REGION,
        });

        const s3 = new AWS.S3();
        const params = {
            Bucket: uploadIdxBucket + '/' + "TempFiles",
            Key: generateCurrentRpmFileName,
            Body: JSON.stringify(currentRPMdata), // convert JSON to string
            ContentType: "application/json", // correct MIME type
        };

        try {
            const data = await s3.upload(params).promise();
            console.log('Upload success:', data.Location);
            ruleSheetUpload(generateCurrentRpmFileName);
        } catch (err) {
            setDotLoader(true);
            console.error('Upload error:', err);
        }
    };

    const validate = () => {
        const newErrors = {};

        if (!ruleType) newErrors.ruleType = "Rule Type is required.";
        if (!usecase) newErrors.usecase = "Usecase is required.";
        if (!client) newErrors.client = "Client is required.";
        if (!file) newErrors.file = "File is required.";

        if (!applyImmediately) {
            if (!startDate) newErrors.startDate = "Start Date is required.";
            if (!endDate) newErrors.endDate = "End Date is required.";
            else if (startDate && endDate && startDate > endDate)
                newErrors.endDate = "End Date cannot be before Start Date.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            // alert("Form submitted successfully!");
            // Process form submission here
            // setshowUploadRuleSet(false);
        }
    };

    // When applyImmediately toggles, clear errors related to dates if disabled
    const onApplyImmediatelyChange = (e) => {
        const checked = e.target.checked;
        setApplyImmediately(checked);

        if (checked) {
            setStartDate(null);
            setEndDate(null);
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors.startDate;
                delete newErrors.endDate;
                return newErrors;
            });
        }
    };

    //Table Begin
    const handleUsecaseChange = (value) => {
        setUsecase(value);
        if (errors.usecase) {
            setErrors((prev) => ({ ...prev, usecase: null }));
        }
        let selectedUsecase = usecaseInfoForUpload.find(x => x.UseCaseId == value);
        setUsecasename(selectedUsecase.UCSN)
        localStorage.setItem('selectedUsecaseName', selectedUsecase.UCSN);
        let getClientListUnderSelectedUseCase = selectedUsecase ? selectedUsecase.Client : [];
        setClientList(getClientListUnderSelectedUseCase)
    }
    const ruleSheetUpload = async (generateCurrentRpmFileName) => {
        setDotLoader(true);
        let removeExtentison = file.name.replace(".xlsx", "")
        let addTimeStamp = removeExtentison + '_' + generateTimestamp() + ".xlsx";
        setRuleFileName(addTimeStamp);
        AWS.config.update({
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            region: configData.LAMBDA_REGION,
        });
        const s3 = new AWS.S3();
        const params = {
            Bucket: uploadIdxBucket + '/' + "TempFiles",
            Key: addTimeStamp,
            Body: file,
            ContentType: file.type,
        };

        try {
            const data = await s3.upload(params).promise();
            console.log('Upload success', data.Location);
            getRpmTableData(generateCurrentRpmFileName, addTimeStamp);

        } catch (err) {
            setDotLoader(true);
            console.error('Upload error', err);
        }
        console.log(file)
    }
    const getRpmTableData = (generateCurrentRpmFileName, uploadrulename) => {
        setDotLoader(true);
        const lambda = new AWS.Lambda({
            region: configData.LAMBDA_REGION,
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
            httpOptions: {
                timeout: 180000
            }
        });
        // Disable SDK-level retries for all AWS services
        AWS.config.update({
            maxRetries: 0
        });
        const data = {
            Task: "CompareRPMData",
            ActionType: "COMPARE",
            CSN: configjson.IDXCSN,
            UCSN: configjson.IDXUCSN,
            RuleTypeId: ruleType,
            FilterLevel: 4,
            BucketName: uploadIdxBucket,
            RuleFileNameWithPath: 'TempFiles/' + uploadrulename,
            CurrentRPMWithPath: 'TempFiles/' + generateCurrentRpmFileName,
            UserName: localStorage.getItem("UserName").trim()

        };
        const params = {
            FunctionName: "CompareAndSaveRPM",
            Payload: JSON.stringify(data)
        };

        lambda.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                const parsedPayload = JSON.parse(data.Payload.toString());
                if (parsedPayload.statusCode === 200) {
                    const parsedBody = JSON.parse(parsedPayload.body);
                    readRpmTableData(parsedBody.JsonBucketName, parsedBody.JsonFileNameWithPath)
                }
                else {
                    setDotLoader(false);
                }
            }
        })
    }
    const readRpmTableData = async (bucketname, filename) => {
        setDotLoader(true);
        const splitsname = filename.split('/');
        let mergeKeyFile = bucketname + '/' + splitsname[0] + '/' + splitsname[1];

        AWS.config.credentials = new AWS.Credentials({
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk'))
        });

        const s3 = new AWS.S3({ signatureVersion: 'v4', region: configData.LAMBDA_REGION });

        const s3Data = await s3.getObject({
            Bucket: mergeKeyFile,
            Key: splitsname[2],
            IfModifiedSince: new Date(0)
        }).promise();

        const dataBuffer = new Uint8Array(s3Data.Body);
        const dataJson = new TextDecoder('utf-8').decode(dataBuffer);
        const getdatajsondata = JSON.parse(dataJson);
        setRpmTableValues(getdatajsondata)
        setUploadDisplayHide(true)
        setTimeout(() => {
            setDotLoader(false);
        }, 1000);
    }
    const calconfigrpm = (e) => {
        setClient(e.target.value);
        let getclientname = clientList.find(x => x.ClientID == e.target.value)
        setClientname(getclientname.CSN)
        localStorage.setItem('selectedClientName', getclientname.CSN);
        ruleConfigForUi(getclientname.CSN);
    }
    const enableloader = () => {
        setDotLoader(true);
    }
    const disableloader = () => {
        setDotLoader(false);

    }
    const resetForms = () => {
        // Reset form
        setRuleType("");
        setUsecase("");
        setClient("");
        setFile(null);
        setApplyImmediately(false);
        setStartDate(null);
        setEndDate(null);
        setErrors({});
    }
    const displayuploadsection = () => {
        resetForms();
        setUploadDisplayHide(false);
    }
    const handleFileChange = (e) => {
        const selected = e.target.files[0] || null;
        setFile(selected);

        if (errors?.file) {
            setErrors((prev) => ({ ...prev, file: null }));
        }
    };

    const handleClear = () => {
        setFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };



    return (
        <Fragment>

            <Row>
                {!uploadDisplayHide && (
                    !dotloader ? (
                        <Col sm={6} className='mt-3'>
                            <div className="d-flex justify-content-between mb-2">
                                <h6>Upload the Rules Excel File</h6>
                                <div><Button variant="outline-success" size='sm' onClick={showDownloadTemplate}><FaDownload className='bounce-icon' />
                                    Download Template</Button></div>
                            </div>
                            <Form onSubmit={onSubmit}>
                                <Form.Group className="mb-3">

                                    <FloatingLabel
                                        controlId="floatingSelect"
                                        label={
                                            <>
                                                Rule Type <span style={{ color: 'red' }}>*</span>
                                            </>
                                        }
                                    >
                                        <Form.Select
                                            aria-label="Select Rule Type"
                                            value={ruleType}
                                            onChange={(e) => {
                                                setRuleType(e.target.value);
                                                if (errors.ruleType) {
                                                    setErrors((prev) => ({ ...prev, ruleType: null }));
                                                }
                                            }}
                                            isInvalid={!!errors.ruleType}
                                        >
                                            <option value="" disabled>Select Rule Type</option>
                                            {/* {ExcelRuleConfigInfoForUpload?.map((el) => (
                                                <option value={el.RuleTypeId}>{el.RuleTypeName}</option>
                                            ))} */}
                                            {ExcelRuleConfigInfoForUpload && ExcelRuleConfigInfoForUpload.length > 0 && (
                                                ExcelRuleConfigInfoForUpload.map((el) => (
                                                    <option key={el.RuleTypeId} value={el.RuleTypeId}>
                                                        {el.RuleTypeName}
                                                    </option>
                                                ))
                                            )}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.ruleType}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3" controlId="usecaseSelect">
                                    <Form.Label column sm="3">
                                        Usecase Name<span style={{ color: 'red' }}>*</span>
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Select
                                            size="sm"
                                            value={usecase}
                                            onChange={(e) => handleUsecaseChange(e.target.value)}
                                            // onChange={(e) => {
                                            //     setUsecase(e.target.value);
                                            //     if (errors.usecase) {
                                            //         setErrors((prev) => ({ ...prev, usecase: null }));
                                            //     }
                                            // }}
                                            isInvalid={!!errors.usecase}
                                        >
                                            <option value="" disabled>Select Usecase</option>
                                            {/* {usecaseInfoForUpload[0]?.UseCase.map((el) => (
                                                <option value={el.UseCaseID}>{el.UseCaseName}</option>
                                            ))} */}
                                            {usecaseInfoForUpload.length > 0 && (
                                                usecaseInfoForUpload.map((el) => (
                                                    <option key={el.UseCaseId} value={el.UseCaseId}>
                                                        {el.UseCaseName}
                                                    </option>
                                                ))
                                            )}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.usecase}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3" controlId="clientSelect">
                                    <Form.Label column sm="3">
                                        Client<span style={{ color: 'red' }}>*</span>
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Select
                                            size="sm"
                                            value={client}
                                            onChange={(e) => {
                                                calconfigrpm(e)
                                                if (errors.client) {
                                                    setErrors((prev) => ({ ...prev, client: null }));
                                                }
                                            }}
                                            isInvalid={!!errors.client}
                                        >
                                            <option value="">Select Client</option>
                                            {clientList.map((option, idx) => (
                                                <option key={idx} value={option.ClientID}>{option.ClientName}</option>
                                            ))}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.client}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>


                                <Form.Group as={Row} className="mb-3" controlId="fileInput">
                                    <Form.Label column sm="3">
                                        Choose File<span style={{ color: 'red' }}>*</span>
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            ref={fileInputRef}
                                            type="file"
                                            onChange={handleFileChange}
                                            isInvalid={!!errors?.file}
                                            style={{ display: 'none' }}
                                        />
                                        <Button variant="outline-primary" className='customfile-upload' size="sm" onClick={triggerFileInput}>
                                            Browse
                                        </Button>
                                        {errors?.file && (
                                            <Form.Control.Feedback type="invalid" className="d-block">
                                                {errors.file}
                                            </Form.Control.Feedback>
                                        )}
                                        {file && (
                                            <div className="mt-2 d-flex justify-content-between align-items-center">
                                                <div><strong>Selected:</strong> {file.name}</div>
                                                <Button variant="outline-danger" size="sm" onClick={handleClear}>
                                                    <IoMdClose />
                                                </Button>
                                            </div>
                                        )}
                                    </Col>
                                </Form.Group>


                                <Form.Group as={Row} className="mb-3" controlId="applyImmediately">
                                    <Col sm="3" className='pe-0'>
                                        <Form.Check
                                            type="checkbox"
                                            label="Apply Immediately (or)"
                                            checked={applyImmediately}
                                            onChange={onApplyImmediatelyChange}
                                        />
                                    </Col>
                                    <Col sm="9">
                                        <Row>
                                            <Col sm={6}>
                                                <DatePicker
                                                    showIcon
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        setStartDate(date);
                                                        if (errors.startDate) {
                                                            setErrors((prev) => ({ ...prev, startDate: null }));
                                                        }
                                                    }}
                                                    isClearable
                                                    placeholderText="Start Date"
                                                    disabled={applyImmediately}
                                                    minDate={new Date()}
                                                    className={`form-control ${errors.startDate ? "is-invalid" : ""}`}
                                                />
                                                {errors.startDate && (
                                                    <div className="invalid-feedback d-block">{errors.startDate}</div>
                                                )}
                                            </Col>
                                            <Col sm={6}>
                                                <DatePicker
                                                    showIcon
                                                    selected={endDate}
                                                    onChange={(date) => {
                                                        setEndDate(date);
                                                        if (errors.endDate) {
                                                            setErrors((prev) => ({ ...prev, endDate: null }));
                                                        }
                                                    }}
                                                    isClearable
                                                    placeholderText="End Date"
                                                    disabled={applyImmediately}
                                                    minDate={new Date()}
                                                    className={`form-control ${errors.endDate ? "is-invalid" : ""}`}
                                                />
                                                {errors.endDate && (
                                                    <div className="invalid-feedback d-block">{errors.endDate}</div>
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Form.Group>

                                <hr />
                                <Row>
                                    <Col sm={12} className="text-end">
                                        <Button
                                            variant="secondary"
                                            size="sm"
                                            className="me-1"
                                            onClick={resetForms}
                                        >
                                            Cancel
                                        </Button>
                                        <Button variant="primary" size="sm" type="submit" onClick={rpmUpload}>
                                            RPM Upload
                                        </Button>

                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    ) : (
                        <div
                            style={{ marginTop: "20%", marginBottom: "20%" }}
                            className="d-flex justify-content-center"
                        >
                            <div className="loader"></div>
                        </div>
                    )
                )}
                {uploadDisplayHide && (
                    !dotloader ? (
                        <RpmTable rpmTableValues={rpmTableValues} ruleFileName={ruleFileName} currentRpmFileName={currentRpmFileName} ruleType={ruleType} configjson={configjson} applyImmediately={applyImmediately} startDate={startDate} endDate={endDate} file={file} enableloader={enableloader} disableloader={disableloader} displayuploadsection={displayuploadsection} />
                    ) : (
                        <div
                            style={{ marginTop: "20%", marginBottom: "20%" }}
                            className="d-flex justify-content-center"
                        >
                            <div className="loader"></div>
                        </div>
                    )
                )}
            </Row>
            <RuleTemplateDownload show={showRuleTemplate} handleClose={closeDownloadTemplate} usecaselistforDownloadTemplate={usecaseInfo} />
        </Fragment>
    );
};

export default UploadRuleSet;